import * as Tooltip from "@radix-ui/react-tooltip";
import { ReactNode } from "react";

type Props = { content: ReactNode; children?: ReactNode };

export default function PlayerMenuSocialTooltip({ content, children }: Props) {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="z-50 w-fit bg-gradient-to-br from-accent-solid/60 to-dark-800 p-4 rounded text-sm shadow-lg animate-fade-in"
            sideOffset={5}
            side="top"
            align="center"
          >
            {content}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
